import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../services/i18nService';

import OptionButton from './OptionButton';

const LanguageButton = ({ clickHandler, a11yAttributes }) => {
    return (<OptionButton
        iconClass="fa fa-globe fa-fw"
        clickHandler={clickHandler}
        title={t('options.language')}
        a11yAttributes={a11yAttributes}
    />);
};

LanguageButton.propTypes = {
    clickHandler: PropTypes.func.isRequired,
    a11yAttributes: PropTypes.object,
};

export default LanguageButton;
